import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackPhoneCall } from '@/lib/gtag';
import { Phone, ChevronDown, ChevronUp, Menu, X } from 'lucide-react';

const Header: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [servicesOpen, setServicesOpen] = React.useState(false);

  const scrollTo = (selector: string) => {
    document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  const services = [
    { id: 'desentupimentos', title: 'Desentupimentos Urgentes' },
    { id: 'fugas', title: 'Detecção de Fugas de Água' },
    { id: 'reparacao', title: 'Reparação de Canalização' },
    { id: 'instalacao', title: 'Instalação de Canalização' },
    { id: 'manutencao', title: 'Manutenção Preventiva' },
    { id: 'pinturas', title: 'Pinturas em Geral' },
    { id: 'limpeza-vidros', title: 'Limpeza de Vidros (Rapel)' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="bg-black/60 backdrop-blur-lg shadow-md border-b border-black/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="h-14 flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer group">
              <div className="h-12 w-12 rounded-full overflow-hidden shadow-md ring-2 ring-[#2563eb]/20 transition-transform duration-300 group-hover:scale-105">
                <img
                  src="data:image/webp;base64,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"
                  alt="PLUMBERS NOW"
                  className="h-full w-full object-cover"
                  loading="eager"
                />
              </div>
            </Link>

            {/* Desktop nav */}
            <nav className="hidden md:flex items-center gap-3 text-sm font-medium text-white">
              <Link
                to="/"
                className="hover:bg-white/20 px-3 py-2 rounded-md hover:text-white transition-colors"
              >
                Home
              </Link>

              {/* Services Dropdown */}
              <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
                <button className="hover:bg-white/20 px-3 py-2 rounded-md hover:text-white transition-colors flex items-center gap-1">
                  Serviços
                  {servicesOpen ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
                </button>
                {servicesOpen && (
                  <div className="absolute top-full left-0 mt-1 w-64 bg-black/90 backdrop-blur-lg rounded-lg shadow-xl border border-white/20 py-2 z-50">
                    {services.map((service) => (
                      <Link
                        key={service.id}
                        to={`/servico/${service.id}`}
                        className="block px-4 py-2 hover:bg-white/20 text-white transition-colors"
                        onClick={() => setServicesOpen(false)}
                      >
                        {service.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/sobre-nos"
                className="hover:bg-white/20 px-3 py-2 rounded-md hover:text-white transition-colors"
              >
                Sobre Nós
              </Link>
              <Link
                to="/contato"
                className="hover:bg-white/20 px-3 py-2 rounded-md hover:text-white transition-colors"
              >
                Contato
              </Link>
              <a
                href="tel:+351960488777"
                className="ml-1 bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded-md transition-colors inline-flex items-center gap-2 shadow-sm font-semibold"
                onClick={() => trackPhoneCall('+351960488777')}
              >
                <Phone className="w-4 h-4" />
                Ligar
              </a>
            </nav>

            {/* Mobile */}
            <button
              aria-label="Abrir menu"
              className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg border border-white/30 text-white bg-white/10 hover:bg-white/20"
              onClick={() => setOpen((v) => !v)}
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
        {/* Mobile drawer */}
        {open && (
          <div className="md:hidden border-t border-white/30 bg-black/60 backdrop-blur-lg">
            <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-3 text-white">
              <Link
                to="/"
                className="text-left py-2 hover:bg-white/20 rounded-md px-2 transition-colors"
                onClick={() => setOpen(false)}
              >
                Home
              </Link>

              {/* Services Mobile */}
              <div>
                <button
                  onClick={() => setServicesOpen(!servicesOpen)}
                  className="w-full text-left py-2 hover:bg-white/20 rounded-md px-2 transition-colors flex items-center justify-between"
                >
                  <span>Serviços</span>
                  {servicesOpen ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                </button>
                {servicesOpen && (
                  <div className="pl-4 mt-2 space-y-1">
                    {services.map((service) => (
                      <Link
                        key={service.id}
                        to={`/servico/${service.id}`}
                        className="block py-2 hover:bg-white/20 rounded-md px-2 transition-colors text-sm"
                        onClick={() => {
                          setOpen(false);
                          setServicesOpen(false);
                        }}
                      >
                        {service.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/sobre-nos"
                className="text-left py-2 hover:bg-white/20 rounded-md px-2 transition-colors"
                onClick={() => setOpen(false)}
              >
                Sobre Nós
              </Link>
              <Link
                to="/contato"
                className="text-left py-2 hover:bg-white/20 rounded-md px-2 transition-colors"
                onClick={() => setOpen(false)}
              >
                Contato
              </Link>
              <a
                href="tel:+351960488777"
                className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded-lg inline-flex items-center gap-2 font-semibold"
                onClick={() => {
                  setOpen(false);
                  trackPhoneCall('+351960488777');
                }}
              >
                <Phone className="w-5 h-5" />
                Ligar agora
              </a>
            </div>
          </div>
        )}
      </div>
      {/* Spacer to avoid content jump */}
      <div className="h-14" />
    </header>
  );
};

export default Header;


